module.exports = __webpack_public_path__ + "static/media/banner2.bb863d0d.png";